export default {
  type: 'my_review_subscriptions',
  name: 'Email List Subscriptions',
  save: {
    fields: [
      { field: 'personId', type: 'Int', required: true },
      'subscriptionRecords'
    ],
    key: ['personId']
  },
  load: {
    key: 'personByPersonId'
  },
  form: {
    print: false,
    redirects: false,
    schema: [
      { type: 'br' },
      { type: 'hr' },
      { type: 'br' },
      {
        type: 'message',
        message:
          '<b><i>Note:</i></b> your request will go through review before implementation - some email subscriptions may be essential to your ARM role and cannot be removed.'
      },
      {
        name: 'subscriptionRecords',
        label: 'My Subscriptions',
        selectedMessage: 'Requested Removal:',
        labelWidth: 12,
        type: 'results',
        fields: [
          {
            key: 'emailList',
            sortable: true,
            required: true
          },
          /*{
            key: 'moderationStatus',
            sortable: true
          },*/
          {
            key: 'description',
            sortable: true
          },
          /*{
            key: 'listLevelDesc',
            label: 'List Access',
            sortable: true
          },*/
          {
            key: 'selected',
            label:
              'Request Removal' /*,
            if: [
              { field: 'listLevel', value: 'I' },
              { field: 'listLevel', value: 'P' },
              { field: 'listLevel', value: 'F' },
              { field: 'listLevel', value: 'C' }
            ]*/
          }
        ]
      },
      {
        name: 'subscribeTo',
        label: 'Request New Subscriptions',
        type: 'graphql_form_search_multi',
        fields: [
          {
            key: 'emailList',
            sortable: true,
            required: true
          },
          /*
          {
            key: 'statusList',
            label: 'Moderation Status',
            type: 'select',
            options: [
              {
                value: 'armpublic',
                text: 'Non-Moderated (Public, no attachments)'
              },
              {
                value: 'armpublicattachments',
                text: 'Non-Moderated (Public, allow attachments)'
              },
              {
                value: 'armprivate',
                text: 'Non-Moderated (Members Only)'
              },
              {
                value: 'armmoderated',
                text: 'Moderated'
              }
            ]
          },
          {
            key: 'topicsList',
            label: 'Description',
            sortable: true
          },
          */
          {
            key: 'remove'
          }
        ],
        formType: 'emails',
        multiHeader: 'Added ${emailList} to subscriptions',
        addLabel: 'Search Available Subscription',
        searchType: 'modal2',
        searchConditions: {
          active: { type: 'Boolean', default: true }
        },
        searchFilters: {
          listLevel: {
            in: {
              type: 'StringArray',
              array: true,
              required: true,
              default: '["I", "P", "F", "C"]'
            }
          }
        }
      },
      {
        name: 'comments',
        type: 'textarea'
      }
    ],
    submitLabel: 'Submit Subscription Update Request'
  }
}
